import { FC, ReactNode } from "react";
import { StyleSheet, TextStyle, View, ViewStyle } from "react-native";
import { useResponsive } from "../../hooks/useResponsive";

type ColumnProps = {
  children?: ReactNode;
  name: string;
  style?: ViewStyle | TextStyle | (ViewStyle | TextStyle)[];
};

export const Column: FC<ColumnProps> = ({ children, name, style }) => {
  const { isSmallAndUp, isXSmallOnly } = useResponsive();
  const grid = () => {
    if (isSmallAndUp) return styles;
    else if (isXSmallOnly) return xSmallStyles;
    else return smallStyles;
  };
  return (
    <View style={[grid()[name], { marginRight: 0 }, style]}>{children}</View>
  );
};

// important: please keep 12 grid system
const styles = StyleSheet.create({
  position: {
    flex: 6,
    maxWidth: 400,
  },
  age: {
    flex: 1.2,
  },
  weight: {
    flex: 1.2,
  },
  originalRating: {
    flex: 1.2,
  },
  rtg: {
    flex: 1.2,
  },
  odds: {
    flex: 1.2,
  },
});

const smallStyles = StyleSheet.create({
  position: {
    flex: 8,
  },
  ageAndWeight: {
    flex: 2,
  },
  rtgAndOdds: {
    flex: 2,
  },
});

const xSmallStyles = StyleSheet.create({
  position: {
    flex: 8,
  },
  ageAndWeight: {
    flex: 2,
  },
  rtgAndOdds: {
    flex: 2,
  },
});
